import React, { useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import { StoreContext } from "../context/StoreContext";
// prettier-ignore
import { TableBody, TableCell, TableHead, TablePagination, TableRow, TableFooter, IconButton, Tooltip, Checkbox } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { subscriptionLevelConst } from "../utils/Constants";

import { _formatDate } from "../utils";

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5)
    }
}));
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3)
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    tableWrapper: {
        overflowX: "auto"
    },
    pointer: {
        cursor: "pointer"
    },
    actionsCellWidth: {
        width: "250px"
    }
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    function handleFirstPageButtonClick(event) {
        onPageChange(event, 0);
    }

    function handleBackButtonClick(event) {
        onPageChange(event, page - 1);
    }

    function handleNextButtonClick(event) {
        onPageChange(event, page + 1);
    }

    function handleLastPageButtonClick(event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    }

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="First Page"
                size="large"
            >
                {theme.direction === "rtl" ? (
                    <LastPageIcon />
                ) : (
                    <FirstPageIcon />
                )}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="Previous Page"
                size="large"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="Next Page"
                size="large"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="Last Page"
                size="large"
            >
                {theme.direction === "rtl" ? (
                    <FirstPageIcon />
                ) : (
                    <LastPageIcon />
                )}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};
export default function CompaniesTable({ companiList, editCompanyClick }) {
    const { actions } = useContext(StoreContext);
    const classes = useStyles();
    const [selectedCompanyId, setSelectedCompanyId] = React.useState();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    useEffect(() => {
        setPage(0);
    }, [companiList]);

    function handleRowClick(event, id) {
        setSelectedCompanyId(id);
        actions.setMode("Edit");
        actions.setId(id);
        editCompanyClick();
    }

    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }

    return (
        <>
            <div className={classes.root}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Contact name</TableCell>
                            <TableCell align="left">Email Address</TableCell>
                            <TableCell align="left">
                                Subscription Level
                            </TableCell>
                            <TableCell align="left">Date Created</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {companiList &&
                            companiList.length > 0 &&
                            companiList
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map(
                                    (
                                        {
                                            name,
                                            contactname,
                                            emailaddress,
                                            id,
                                            addressoneline,
                                            subscriptionLevel,
                                            createdAt
                                        },
                                        i
                                    ) => {
                                        return (
                                            <TableRow
                                                key={id}
                                                hover
                                                onClick={(event) =>
                                                    handleRowClick(event, id)
                                                }
                                                selected={
                                                    selectedCompanyId === id
                                                }
                                            >
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    style={{
                                                        maxWidth: "162px",
                                                        whiteSpace: "normal",
                                                        wordWrap: "break-word"
                                                    }}
                                                >
                                                    {name}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {contactname}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {emailaddress}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textTransform:
                                                            "capitalize"
                                                    }}
                                                    align="left"
                                                >
                                                    {subscriptionLevel
                                                        ? subscriptionLevelConst.find(
                                                              (sub) =>
                                                                  sub.value ===
                                                                  subscriptionLevel
                                                          ).label
                                                        : ""}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {_formatDate(createdAt)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                )}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                colSpan={6}
                                count={companiList.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        "aria-label": "Rows per page"
                                    },
                                    native: true
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </div>
        </>
    );
}
